import Help from "."

export const paths = [
    {
        path: "/help",
        component: Help

    }
]

export const HelpRouters = {
    icon: "question",
    label: "Ajuda",
    path: '/help',
    tree: [

    ]
}


// WEBPACK FOOTER //
// ./src/views/AppViews/Help/routers.js